import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import http from "../http";

const viewed = JSON.parse(window.localStorage.getItem('yetaiViewed')) || [];
const liked = JSON.parse(window.localStorage.getItem('yetaiLiked')) || [];

const initialState = {
    data: [],//浏览记录
    wechatData: null,
    yetaiViewed: viewed,
    yetaiLiked: liked,

}

//搜索的业态(和search一样)
export const fetchYetaiSearchMy = createAsyncThunk('yetaiSearch', async (requestData, thunkAPI) => {
    try {
        console.log(requestData)

        const response = await http.post('/v1/business_search', requestData);
        return response.data; // 返回获取到的数据
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // 返回错误信息
    }
});

const slice = createSlice({
    name: 'my',
    initialState,
    reducers: {
        // auth(state, action) {
        //     if (state.data) {
        //         state.wechatData = state.data.filter(e => {
        //             console.log(e.stype, action.payload)
        //             return e.stype == action.payload
        //         })
        //     }
        // },
        ClearData(state, action) {
            state.data.length = 0;
        },
        addRecord(state, action) {
            state.yetaiViewed.unshift(action.payload)
            state.yetaiViewed = [...new Set(state.yetaiViewed)];
            if (state.yetaiViewed.length > 20) {
                state.yetaiViewed.length = 20
            }
            window.localStorage.setItem('yetaiViewed', JSON.stringify(state.yetaiViewed));
        },
        addLiked(state, action) {
            if(state.yetaiLiked.indexOf(action.payload)!=-1){
                state.yetaiLiked.splice(state.yetaiLiked.indexOf(action.payload),1);
            }
            else{
                state.yetaiLiked.unshift(action.payload)
            }

            
            state.yetaiLiked = [...new Set(state.yetaiLiked)];
            if (state.yetaiLiked.length > 50) {
                state.yetaiLiked.length = 50
            }

            window.localStorage.setItem('yetaiLiked', JSON.stringify(state.yetaiLiked));
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchYetaiSearchMy.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchYetaiSearchMy.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.data = action.payload.item.business;
                }
                else {
                    state.data = null;
                }

            })
            .addCase(fetchYetaiSearchMy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})
export const { addRecord,addLiked,ClearData } = slice.actions

export default slice.reducer